module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('div', {
    staticClass: "head"
  }, [_m(0), " ", _h('div', {
    staticClass: "output"
  }, [_h('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (src),
      expression: "src"
    }],
    attrs: {
      "src": src,
      "alt": "Select a picture"
    },
    on: {
      "click": upload
    }
  }), " ", _h('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!src),
      expression: "!src"
    }],
    staticClass: "uploader",
    on: {
      "click": upload
    }
  }, ["Select a picture"]), " ", _h('input', {
    attrs: {
      "type": "file",
      "capture": "camera",
      "accept": "image/*",
      "id": "upload-btn",
      "hidden": ""
    },
    on: {
      "change": getFile
    }
  })])]), " ", _h('Counter', {
    attrs: {
      "type": "ddv",
      "order": "5"
    }
  }, [_m(1)]), " ", _h('Counter', {
    attrs: {
      "type": "pr",
      "order": "0.005"
    }
  }, [_m(2)]), " ", _h('Counter', {
    attrs: {
      "type": "pmn",
      "order": "100"
    }
  }, [_m(3)]), " ", _h('Counter', {
    attrs: {
      "type": "bs",
      "order": "1"
    }
  }, [_m(4)]), " ", _h('Counter', {
    attrs: {
      "type": "es",
      "order": "1"
    }
  }, [_m(5)]), " ", _h('Counter', {
    attrs: {
      "type": "pl",
      "order": "1000"
    }
  }, [_m(6)]), " ", _h('button', {
    staticClass: "generate-btn",
    on: {
      "click": styling
    }
  }, [_h('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (working),
      expression: "working"
    }],
    staticClass: "spinner"
  }, ["―"]), " ", _h('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!working),
      expression: "!working"
    }]
  }, ["Generate"])])])
}},staticRenderFns: [function (){with(this) {
  return _h('h1', ["\n      Low-Poly\n      ", _h('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": ""
    }
  })])
}},function (){with(this) {
  return _h('span', {
    staticClass: "counter-name"
  }, ["Edge detact value:"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "counter-name"
  }, ["Point rate:"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "counter-name"
  }, ["Point max number:"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "counter-name"
  }, ["Blur size:"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "counter-name"
  }, ["Edge size:"])
}},function (){with(this) {
  return _h('span', {
    staticClass: "counter-name"
  }, ["Pixel limit:"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.9.7.0@vue-loader/lib/template-compiler.js?id=data-v-356d323f!./~/.9.7.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 12
 ** module chunks = 1
 **/